const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowitLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.2,-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2,6C37.9,6 9.2,34.7 9.2,70C9.2,105.3 37.9,134 73.2,134C108.5,134 137.2,105.3 137.2,70C137.2,34.7 108.6,6 73.2,6ZM93.5,74.8C93.4,80.1 91.5,85.5 88.2,90.1C84.9,94.6 80.4,97.9 75.9,99L33,99L33,98.1C32.8,93.3 34.7,87.7 38.4,82.8C41.9,78.2 46.5,74.8 50.6,73.8L93.5,73.8L93.5,74.8ZM113.5,41.9C113.4,47.2 111.5,52.6 108.2,57.2C104.9,61.7 100.4,65 95.9,66.1L53,66.1L53,65.2C52.8,60.4 54.7,54.8 58.4,49.9C61.9,45.3 66.5,41.9 70.6,40.9L113.5,40.9L113.5,41.9Z",
    style: {
      fill: "rgb(39,39,39)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowitLogoNoText);
export default __webpack_public_path__ + "static/media/showit-logo-no-text.ff74808ee6e07c4add59c572ae5a01b0.svg";
export { ForwardRef as ReactComponent };